import { INodeTemplate } from '@/types/node';
import { Edit } from './edit';
import { Render } from './render';

const template: INodeTemplate = {
  version: 1,
  name: 'Forum List',
  icon: 'speaker_notes',
  type: 'forum-list',
  tag: 'interactivity',
  content: {
    limit: 5,
    types: 'all',
  },
  override: {
    root: {},
  },
  supports: {
    contexts: ['page'],
    appender: true,
  },
};

export { template, Render, Edit };
